import { IPrice } from '../../../i18n/price/IPrice';

export function adaptPriceToTrackingValue(price: IPrice): number {
	return price.decimalValue;
}
